import styled from '@emotion/styled'
import { Text } from 'theme-ui'

import { WithTheme } from './../../../setup/index'
import media from './../../../common/MediaQueries'

const FormulaStyled = styled.div``

const FormulaHeadingStyled = styled.div<WithTheme>`
  padding: 1.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0rem 0.1875rem 0.375rem 0rem rgba(0, 0, 0, 0.32);
  color: ${({ theme }) => theme.colors.green};
  font-size: 1.0625rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  text-align: center;
  width: 100%;
  margin-bottom: 3.375rem;
`

const FormulaTitleStyled = styled(Text)<WithTheme>`
  font-size: 17px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 1.4;
  margin-bottom: 32px;
`

const FormulaBadgeStyled = styled.div`
  display: flex;
  margin-bottom: 1.5rem;
`

const FormulaListStyled = styled.ul`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  margin: 0 -50px;

  @media ${media.phone} {
    flex-direction: row;
  }
`

const FormulaListItemStyled = styled.li`
  width: 100%;
  padding: 0 3.125rem 1.5rem;

  @media ${media.phone} {
    padding: 0 3.125rem 3.375rem;
    flex-basis: 50%;
    max-width: 50%;
  }
`

const FormulaListItemContentStyled = styled.div<WithTheme>`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1.5rem 2rem 1.25rem;
  box-shadow: 0rem 0.1875rem 0.375rem 0rem rgba(0, 0, 0, 0.32);
  text-align: center;
`

const FormulaListItemContentTitleStyled = styled(Text)`
  font-weight: 500;
  font-size: 1.0625rem;
  color: ${({ theme }) => theme.colors.gray7};
  margin-bottom: 1.25rem;
`

const FormulaListItemContentDescStyled = styled(Text)<WithTheme>`
  font-size: 1.25rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 1.2;
`

const FormulaNoteStyled = styled.div<WithTheme>`
  width: 100%;
  max-width: 560px;
  margin-top: 1.5rem;
  *:not([class]) {
    font-size: 1.0625rem;
    line-height: 1.5;
    margin-bottom: 1rem;
  }

  .strong-green-underline {
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    color: ${({ theme }) => theme.colors.green};
    text-decoration: underline;
  }
`

export {
  FormulaStyled,
  FormulaHeadingStyled,
  FormulaTitleStyled,
  FormulaBadgeStyled,
  FormulaListStyled,
  FormulaListItemStyled,
  FormulaListItemContentStyled,
  FormulaListItemContentTitleStyled,
  FormulaListItemContentDescStyled,
  FormulaNoteStyled
}
